import { API_APARTMENT_INIT } from '../consts/endpoints'
import { csrfJsonFetch } from '../../functions/csrfFetch'

export const fetchPossibleData = async () => {
    const response = await csrfJsonFetch(API_APARTMENT_INIT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
    });

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message);
    }

    return dataResponse;
}
